var cov_28w2livq0i = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Popover/index.tsx",
      hash = "5fd68d78502c6a83023aa72f0ab88c81a4cdc1ee",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Popover/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 7,
          column: 29
        }
      },
      "1": {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 8,
          column: 39
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 25
        }
      },
      "3": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 10,
          column: 54
        }
      },
      "4": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 25
        }
      },
      "5": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 54
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _Popover from './Panel';
import Confirm from './Confirm';
import Content from './Content';
var Popover = (cov_28w2livq0i.s[0]++, _Popover);
cov_28w2livq0i.s[1]++;
Popover.displayName = 'ShineoutPopover';
cov_28w2livq0i.s[2]++;
Popover.Confirm = Confirm;
cov_28w2livq0i.s[3]++;
Popover.Confirm.displayName = 'ShineoutPopoverConfirm';
cov_28w2livq0i.s[4]++;
Popover.Content = Content;
cov_28w2livq0i.s[5]++;
Popover.Content.displayName = 'ShineoutPopoverContent';
export default Popover;